<script>
    import Select from 'svelte-select'
    import {updateUser} from "../firestore";

    export let user;
    export let organizations = []
    export let roles = []

    let saving = false;

    let organizationItems = []
    let selectedOrganization = undefined;

    let roleItems = []
    let selectedRole = undefined;

    updateOrganizations(organizations);
    updateRoles(roles);

    function updateOrganizations(organizationList) {
        organizationItems = organizationList.map(organization => ({value: organization.id, label: organization.name}))
        selectedOrganization = organizationItems.find(organization => organization.value === user.client);
    }

    function updateRoles(roleList) {
        roleItems = roleList.map(role => ({value: role.id, label: role.name}))
        if (user.role !== undefined)
            selectedRole = roleItems.find(role => role.value === user.role.id)
    }

    function handleRoleSelect(event) {
        if(saving){
            user.role = firebase.firestore().collection("roles").doc(event.detail.value);
            updateUser(user);
        }
    }

    function handleOrganizationSelect(event){
        if(saving){
            user.client = event.detail.value;
            updateUser(user);
        }
    }

    saving = true;
</script>

<tr>
    <td>
        <div>{user.email}</div>
    </td>
    <td>
        <Select items={organizationItems} bind:selectedValue={selectedOrganization} on:select={handleOrganizationSelect} isClearable={false}/>
    </td>
    <td>
        <Select items={roleItems} selectedValue={selectedRole} on:select={handleRoleSelect} isClearable={false}/>
    </td>
</tr>
